// import Vue from 'vue';
// export const EventBus = new Vue();
import mitt from 'mitt'
export const EventBus = mitt()